export default __webpack_public_path__ + "static/media/arrow_down.93402310.svg";